
<ion-item lines="none">
  <ion-label>Label</ion-label>
  <input
    type="file"
    value=""
    class="fileInput"
    id="beerImageLabel"
    name="beerImageLabel"
    (change)="uploadFile($event)"
    #beerImageLabel
    />
  @if (!item.image && !displayWaitingForImage()) {
    <ion-button (click)="beerImageLabel.click()" slot="end" fill="clear" shape="round" color="success" size="default">
      <ion-icon size="default" slot="icon-only" name="add-circle-outline"></ion-icon>
    </ion-button>
  }
  @if (item.image) {
    <ion-thumbnail>
      @if (!isUploadedImage) {
        <img [src]="item.image" />
      }
      @if (isUploadedImage) {
        <ion-spinner
          name="lines-small"
        ></ion-spinner>
      }
    </ion-thumbnail>
  }
  @if (item.image) {
    <ion-button
      (click)="confirmDeleteImage()"
      slot="end" fill="clear" shape="round" color="danger" size="default"
      >
      <ion-icon
        size="small" slot="icon-only" name="trash-outline"
      ></ion-icon>
    </ion-button>
  }
  @if (displayWaitingForImage()) {
    <div>
      <ion-spinner name="lines-small"></ion-spinner>
    </div>
  }
  @if (percentage() && percentage() > 0 && percentage() < 100) {
    <div>
      Progress: {{ percentage() | number }}%
      <ion-progress-bar value="{{ percentage() / 100 }}"></ion-progress-bar>
    </div>
  }



</ion-item>

@if (isUploadingImage) {
  <ion-item class="ion-text-center">
    <ion-card>
      <ion-card-header>
        <ion-card-title
          >Selected File:<b>{{ fileName }}</b></ion-card-title
          >
        </ion-card-header>
        <ion-card-content>
          @if (snapshot | async; as snap) {
            <div>
              @if (snapshot && snap.bytesTransferred != snap.totalBytes) {
                <div>
                  <ion-button
                    color="warning"
                    size="small"
                    (click)="task.pause()"
                    class="button is-warning"
                    >Pause</ion-button
                    >
                    <ion-button
                      size="small"
                      (click)="task.resume()"
                      class="button is-info"
                      >Resume</ion-button
                      >
                      <ion-button
                        color="danger"
                        size="small"
                        (click)="task.cancel()"
                        class="button is-danger"
                        >Cancel</ion-button
                        >
                      </div>
                    }
                  </div>
                }
              </ion-card-content>
            </ion-card>
          </ion-item>
        }
